import { ReactNode } from 'react'
import { LocationContext, OptionsContext, PanelContext } from './contexts'
import { usePanelHistoryTop } from '../store.hooks'
import { PanelHistoryItem } from '../history.types'
import { useRunOnce } from '../utils/hooks'
import { Store } from '../store'
import { RouterOptions } from '../types'

export function Router({
  children,
  initialItem,
  options,
}: {
  children: ReactNode
  initialItem?: PanelHistoryItem
  options?: RouterOptions
}) {
  useRunOnce(() => {
    if (!initialItem) return

    const rootHistory = Store.getPanelHistory('root')
    if (!rootHistory?.length) {
      rootHistory.push(initialItem)
      Store.commit()
    }
  })
  const { location } = usePanelHistoryTop('root')

  return (
    <LocationContext.Provider value={location}>
      <PanelContext.Provider value={{ name: 'root', parent: null }}>
        <OptionsContext.Provider value={options || {}}>
          {children}
        </OptionsContext.Provider>
      </PanelContext.Provider>
    </LocationContext.Provider>
  )
}
